export default __webpack_public_path__ + "static/media/Logo-cmtech-sm-600px.45db4aff.svg";